import React, { useState } from 'react';
import { IconQuestionCircle, IconChevronDown, IconArrowRight } from './Icons';
import { useLanguage } from '../context/LanguageContext';
import useScrollReveal from '../hooks/useScrollReveal';
import './FAQ.css';

const FAQ = () => {
  const { t } = useLanguage();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    { question: t.faq.q1, answer: t.faq.a1 },
    { question: t.faq.q2, answer: t.faq.a2 },
    { question: t.faq.q3, answer: t.faq.a3 },
    { question: t.faq.q4, answer: t.faq.a4 },
    { question: t.faq.q5, answer: t.faq.a5 },
    { question: t.faq.q6, answer: t.faq.a6 },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const headerReveal = useScrollReveal({ threshold: 0.2 });
  const listReveal = useScrollReveal({ threshold: 0.1 });

  return (
    <section className="faq-fox" id="faq">
      <div className="faq-fox__container">
        <div ref={headerReveal.ref} className={`faq-fox__header reveal ${headerReveal.isRevealed ? 'reveal--visible' : ''}`}>
          <span className="faq-fox__label"><IconQuestionCircle size={22} />{t.faq.label}</span>
          <h2 className="faq-fox__title">
            {t.faq.title} <span className="faq-fox__title-gradient">{t.faq.titleHighlight}</span>
          </h2>
        </div>
        <div ref={listReveal.ref} className={`faq-fox__list reveal ${listReveal.isRevealed ? 'reveal--visible' : ''}`}>
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-fox__item reveal-child ${openIndex === index ? 'faq-fox__item--open' : ''}`}>
              <button className="faq-fox__question" onClick={() => toggleFAQ(index)} aria-expanded={openIndex === index}>
                <span className="faq-fox__icon">
                  {openIndex === index ? <IconChevronDown size={16} /> : <IconArrowRight size={16} />}
                </span>
                <span className="faq-fox__question-text">{faq.question}</span>
              </button>
              {openIndex === index && (
                <div className="faq-fox__answer"><p>{faq.answer}</p></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
